import moment from "moment";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import {
  Dimensions,
  Modal,
  StyleSheet,
  TouchableOpacity,
  Text,
  View,
  TextInput,
} from "react-native";
//import DatePicker from "react-native-date-picker";
import { SvgCssUri } from "react-native-svg";
import { useSelector } from "react-redux";
import { Color, globalFontStyle, globalStyle } from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import Width from "../../../assets/Width";
import CustomButton from "../../../commonComponents/CustomButton";
import CustomInput from "../../../commonComponents/CustomInput";
import {add_rounded, cancel_black, cancel_yes} from "../../../utils/images";
import { Network } from "../../../utils/network";
import {globalConfigurableData} from "../../../utils/globalConstant";
//import resolveAssetSource from "react-native/Libraries/Image/resolveAssetSource";
//import FastImage from 'react-native-fast-image';

const CreateClub = ({
  setLoaderVisibility,
  onConfirmationChangeScreen,
  eventData,
}) => {
  const [open, setOpen] = useState(false);

  const [open1, setOpen1] = useState(false);
  const [endDateError, setEndDateError] = useState(null);

  const [optionsList, setOptionsList] = useState(
    eventData?.optionsArr
      ? eventData?.optionsArr.length === 4
        ? ["option1", "option2", "option3", "option4"]
        : eventData?.optionsArr.length === 3
        ? ["option1", "option2", "option3"]
        : ["option1", "option2"]
      : ["option1", "option2"]
  );
  const globalConfigData = useSelector(
    (state) => state.utilReducer.globalConfigData
  );

  const {
    control,
    formState: { errors, isValid, isSubmitting },
    handleSubmit,
    reset,
    watch,
    setValue,
  } = useForm({ mode: "onChange" });
  const [categoryError, setCategoryError] = useState(null);
  const [selectedCategory, setSelectedCategory] = React.useState(
    eventData?.category
      ? eventData?.category
      : globalConfigData?.clubEventCategories
      ? globalConfigData?.clubEventCategories[0]?.text
      : null
  );
  const [selectedImg, setSelectedImg] = React.useState(
    eventData?.event_img
      ? eventData?.event_img
      : globalConfigData?.clubEventCategories
      ? globalConfigData?.clubEventCategories[0]?.image_url
      : null
  );

  const watchStartDate = watch("startDate");
  const watchEndDate = watch("endDate");

  function addOptions(e) {
    let tempList;
    if (optionsList.includes("option3")) {
      tempList = [...optionsList, "option4"];
      setOptionsList(tempList);
    } else {
      tempList = [...optionsList, "option3"];
      setOptionsList(tempList);
    }
  }

  function removeOptions(i) {
    if (optionsList.indexOf(i) > -1) {
      optionsList.splice(optionsList.indexOf(i), 1);
      setOptionsList([...optionsList]);
    }
  }

  function handleClickCategories(c, i, e) {
    if (categoryError) {
      setCategoryError(null);
    }

    setSelectedCategory(c);
    setSelectedImg(i);
  }

  const onSubmit = (data) => {
    let optionsArr = [];
    let options = [];
    if (selectedCategory === null) {
      setCategoryError("Please select a category");
      return;
    }
    if (Date.parse(data?.endDate) < Date.parse(data?.startDate)) {
      setEndDateError("End time can not be before start time");
      return;
    }
    optionsList.map((key) => {
      optionsArr.push(data[key]);
      options.push({
        id: key,
        label: data[key],
      });
    });

    console.log(data);

    const createData = {
      title: data?.marketTitle,
      rules: data?.marketResolution,
      start_time: data?.startDate,
      category: selectedCategory,
      end_time: data?.endDate,
      settles_at: data?.endDate,
      event_img: selectedImg,
      optionsArr,
      options,
    };

    onConfirmationChangeScreen(createData);

    //onConfirmationChangeScreen(createData);
  };
  useEffect(() => {
    let defaultValues = {};
    defaultValues.marketTitle = eventData?.title ? eventData.title : null;
    defaultValues.marketResolution = eventData?.rules ? eventData.rules : null;
    defaultValues.option1 = eventData?.optionsArr
      ? eventData?.optionsArr[0]
      : null;
    defaultValues.option2 = eventData?.optionsArr
      ? eventData?.optionsArr[1]
      : null;
    defaultValues.option3 = eventData?.optionsArr
      ? eventData.optionsArr[2]
      : null;
    defaultValues.option4 = eventData?.optionsArr
      ? eventData.optionsArr[3]
      : null;
    defaultValues.startDate = eventData?.start_time
      ? eventData.start_time
      : new Date();
    defaultValues.endDate = eventData?.end_time
      ? eventData.end_time
      : new Date();
    reset({ ...defaultValues });
  }, []);
  const TitleBox = ({ title, text }) => {
    return (
      <View style={{ marginBottom: 13, marginTop: 20 }}>
        <Text
          style={[globalFontStyle.appFontSubHeading, { color: Color.black }]}
        >
          {title}
        </Text>
        <Text style={globalFontStyle.appFontSmallText}>{text}</Text>
      </View>
    );
  };
  return (
    <View style={{ flex: 1, position: "relative" }}>
      <View
        style={{
          paddingHorizontal: 12,
          marginTop: 30,
          marginBottom: 100,
          flex: 1,
        }}
      >
        <TitleBox
          title={"Enter Title"}
          text={"Enter your event heading here."}
        />
        <View style={{ borderWidth: 0.75, borderColor: Color.grey6 }}>
          <Controller
            control={control}
            name="marketTitle"
            rules={{ required: "Please enter start date/time" }}
            render={({ field: { value, onChange } }) => (
              <TextInput
                editable
                multiline
                numberOfLines={3}
                maxLength={80}
                onChangeText={onChange}
                value={value}
                style={{ padding: 10 }}
              />
            )}
          />
        </View>
        {errors?.marketTitle?.type === "required" && (
          <Text style={globalStyle.errorText}>Please enter event title</Text>
        )}

        <TitleBox
          title={"Enter options"}
          text={
            "If your event has different ranges, please write here. (Max 4)"
          }
        />
        {optionsList.map((data, index) => {
          return (
            <View key={data} style={{ marginVertical: 5 }}>
              <CustomInput
                name={data}
                control={control}
                isTextAlignLeft={true}
                isTextInput={true}
                placeholder={"eg: 301-320 runs"}
                rules={{
                  required: true,
                }}
              />
              {index >= 2 && (
                <Text
                  style={{
                    position: "absolute",
                    right: 10,
                    top: 8,
                  }}
                  onPress={(e) => removeOptions(data, e)}
                >
                  <FastImage
                    resizeMode={FastImage.resizeMode.contain}
                    style={{ height: 16, width: 16 }}
                    source={globalConfigurableData?.cancel_black()}
                  />
                </Text>
              )}
            </View>
          );
        })}
        {(errors?.option1?.type === "required" ||
          errors?.option2?.type === "required" ||
          errors?.option3?.type === "required" ||
          errors?.option4?.type === "required") && (
          <Text style={globalStyle.errorText}>Please enter options</Text>
        )}
        {optionsList.length <= 3 && (
          <TouchableOpacity
            onPress={addOptions}
            style={{ flexDirection: "row" }}
          >
            {/*<SvgCssUri
              width="16"
              height="16"
              uri={resolveAssetSource(add_rounded()).uri}
        />*/}
            <FastImage
              style={{
                width: 20,
                height: 20,
              }}
              source={add_rounded()}
            />
            <Text style={{ color: Color.tradexBlue }}>Add an option</Text>
          </TouchableOpacity>
        )}
        <TitleBox
          title={"Market Resolution"}
          text={"Enter rules for market settlement here"}
        />
        <View style={{ borderWidth: 0.75, borderColor: Color.grey6 }}>
          <Controller
            control={control}
            name="marketResolution"
            rules={{ required: true }}
            render={({ field: { value, onChange } }) => (
              <TextInput
                editable
                multiline
                numberOfLines={3}
                maxLength={100}
                onChangeText={onChange}
                value={value}
                style={{ padding: 10 }}
              />
            )}
          />
        </View>
        {errors?.marketResolution?.type === "required" && (
          <Text style={globalStyle.errorText}>
            Please enter market resolution
          </Text>
        )}

        <TitleBox title={"Event Category"} text={""} />
        <View
          style={{
            flexWrap: "wrap",
            justifyContent: "space-between",
            flexDirection: "row",
          }}
        >
          {globalConfigData?.clubEventCategories &&
            globalConfigData?.clubEventCategories.map((item, index) => {
              return (
                <TouchableOpacity
                  onPress={() =>
                    handleClickCategories(item?.text, item?.image_url)
                  }
                  style={[
                    {
                      borderWidth: 0.75,
                      borderColor: Color.grey6,
                      paddingVertical: 12,
                      alignItems: "center",
                    },
                    index ===
                      globalConfigData?.clubEventCategories.length - 1 &&
                    (index + 1) % 2 !== 0
                      ? {
                          marginBottom: 15,
                          width: Width.width - 45,
                        }
                      : {
                          width: Width.width / 2 - 25,
                          marginBottom: 15,
                        },
                    selectedCategory === item?.text
                      ? { backgroundColor: Colors.blue1, color: Colors.bgWhite }
                      : {},
                  ]}
                >
                  <Text
                    style={
                      selectedCategory === item?.text
                        ? { color: Colors.bgWhite }
                        : {}
                    }
                  >
                    {item?.text}
                  </Text>
                </TouchableOpacity>
              );
            })}
        </View>

        <TitleBox
          title={"Enter Start & End Time"}
          text={
            "Your event will start & end automatically as per your given time"
          }
        />
        <View>
          <Text>Start Time</Text>
          <View style={{ flexDirection: "row" }}>
            <View style={{ flex: 1 }}>
              <TouchableOpacity
                onPress={() => {
                  setOpen(true);
                }}
                style={{
                  borderWidth: 0.75,
                  borderColor: Color.grey6,
                  paddingVertical: 10,
                  paddingHorizontal: 5,
                }}
              >
                <View>
                  <Text placeholder="DD/MM/YYYY">
                    {moment(watchStartDate).format("MMM DD YYYY HH:mm")}{" "}
                  </Text>
                </View>
              </TouchableOpacity>
              <Controller
                control={control}
                name="startDate"
                rules={{ required: "Please enter start date/time" }}
                render={({ field: { onChange } }) => (
                  <></>
                  // <DatePicker
                  //   modal
                  //   open={open}
                  //   date={new Date()}
                  //   mode="datetime"
                  //   onConfirm={(date) => {
                  //     onChange(date);
                  //     setOpen(false);
                  //     //setStartDate(date);
                  //   }}
                  //   onCancel={() => {
                  //     setOpen(false);
                  //     // setStartDate(false);
                  //   }}
                  // />
                )}
              />
              {errors?.startDate?.type === "required" && (
                <Text style={globalStyle.errorText}>
                  Please enter start date
                </Text>
              )}
            </View>
            {/*<View style={{flex: 0.8, marginLeft: 10}}>
            <TouchableOpacity
              onPress={() => {
                setOpenTimeStart(true);
              }}
              style={{
                borderWidth: 0.75,
                borderColor: Color.grey6,
                paddingVertical: 10,
                paddingHorizontal: 5,
              }}>
              <View>
                <Text placeholder="DD/MM/YYYY">
                  {moment(watchStartTime).format('HH:mm')}{' '}
                </Text>
              </View>
            </TouchableOpacity>
            <Controller
              control={control}
              name="startTime"
              rules={{required: 'Please enter start date/time'}}
              render={({field: {onChange}}) => (
                <DatePicker
                  modal
                  open={openTimeStart}
                  date={new Date()}
                  mode="time"
                  onConfirm={date => {
                    onChange(date);
                    setOpenTimeStart(false);
                    //setStartDate(date);
                  }}
                  onCancel={() => {
                    setOpenTimeStart(false);
                    // setStartDate(false);
                  }}
                />
              )}
            />
            {errors?.startDate?.type === 'required' && (
              <Text className="error-display error-padding">
                Please enter start date
              </Text>
            )}
            </View>*/}
          </View>
        </View>
        <View style={{ marginTop: 10 }}>
          <Text>End Time</Text>
          <View style={{ flexDirection: "row" }}>
            <View style={{ flex: 1 }}>
              <TouchableOpacity
                onPress={() => {
                  setOpen1(true);
                }}
                style={{
                  borderWidth: 0.75,
                  borderColor: Color.grey6,
                  paddingVertical: 10,
                  paddingHorizontal: 5,
                }}
              >
                <View>
                  <Text placeholder="DD/MM/YYYY">
                    {moment(watchEndDate).format("MMM DD YYYY HH:mm")}{" "}
                  </Text>
                </View>
              </TouchableOpacity>
              <Controller
                control={control}
                name="endDate"
                rules={{ required: "Please enter end date/time" }}
                render={({ field: { onChange } }) => (
                  <></>
                  // <DatePicker
                  //   modal
                  //   open={open1}
                  //   date={new Date()}
                  //   mode="datetime"
                  //   onConfirm={(date) => {
                  //     onChange(date);
                  //     setOpen1(false);
                  //     //setStartDate(date);
                  //   }}
                  //   onCancel={() => {
                  //     setOpen1(false);
                  //     // setStartDate(false);
                  //   }}
                  // />
                )}
              />
              {errors?.startDate?.type === "required" && (
                <Text style={globalStyle.errorText}>Please enter end date</Text>
              )}
              {endDateError && (
                <Text style={globalStyle.errorText}>{endDateError}</Text>
              )}
            </View>
            {/*<View style={{flex: 0.8, marginLeft: 10}}>
            <TouchableOpacity
              onPress={() => {
                setOpenTimeEnd(true);
              }}
              style={{
                borderWidth: 0.75,
                borderColor: Color.grey6,
                paddingVertical: 10,
                paddingHorizontal: 5,
              }}>
              <View>
                <Text placeholder="DD/MM/YYYY">
                  {moment(watchEndTime).format('HH:mm')}{' '}
                </Text>
              </View>
            </TouchableOpacity>
            <Controller
              control={control}
              name="endTime"
              rules={{required: 'Please enter start date/time'}}
              render={({field: {onChange}}) => (
                <DatePicker
                  modal
                  open={openTimeEnd}
                  date={new Date()}
                  mode="time"
                  onConfirm={date => {
                    onChange(date);
                    setOpenTimeEnd(false);
                    //setStartDate(date);
                  }}
                  onCancel={() => {
                    setOpenTimeEnd(false);
                    // setStartDate(false);
                  }}
                />
              )}
            />
            {errors?.startDate?.type === 'required' && (
              <Text className="error-display error-padding">
                Please enter start date
              </Text>
            )}
            </View>*/}
          </View>
        </View>
      </View>
      <View style={[globalStyle.bottomAbsBtnBar, { alignSelf: "flex-end" }]}>
        <CustomButton
          btnText={"Proceed"}
          btnType="normalBlue"
          onBtnClick={handleSubmit(onSubmit)}
        />
      </View>
    </View>
  );
};

export default CreateClub;
